import { useEffect, useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(null);

  useEffect(() => {
    // Prevent browser from restoring old scroll position on navigation/reload.
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  // Reset scroll on real route changes only. Query/hash updates (e.g. buy-home ?categoryname=) must not jump to top.
  useLayoutEffect(() => {
    if (prevPathnameRef.current === pathname) {
      return;
    }
    prevPathnameRef.current = pathname;

    const scrollTopNow = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Immediate + next frame to avoid late content pushing view downward.
    scrollTopNow();
    const raf = requestAnimationFrame(scrollTopNow);
    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return null;
};

export default ScrollToTop;





